/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NqlQueryParamsDTO } from './NqlQueryParamsDTO';
import {
    NqlQueryParamsDTOFromJSON,
    NqlQueryParamsDTOFromJSONTyped,
    NqlQueryParamsDTOToJSON,
} from './NqlQueryParamsDTO';
import type { QueryLeaderboardParamsSortingParamsDTO } from './QueryLeaderboardParamsSortingParamsDTO';
import {
    QueryLeaderboardParamsSortingParamsDTOFromJSON,
    QueryLeaderboardParamsSortingParamsDTOFromJSONTyped,
    QueryLeaderboardParamsSortingParamsDTOToJSON,
} from './QueryLeaderboardParamsSortingParamsDTO';
import type { QueryLeaderboardParamsPaginationDTO } from './QueryLeaderboardParamsPaginationDTO';
import {
    QueryLeaderboardParamsPaginationDTOFromJSON,
    QueryLeaderboardParamsPaginationDTOFromJSONTyped,
    QueryLeaderboardParamsPaginationDTOToJSON,
} from './QueryLeaderboardParamsPaginationDTO';

/**
 * 
 * @export
 * @interface SearchUserRunsParamsDTO
 */
export interface SearchUserRunsParamsDTO {
    /**
     * 
     * @type {boolean}
     * @memberof SearchUserRunsParamsDTO
     */
    experimentLeader?: boolean;
    /**
     * 
     * @type {QueryLeaderboardParamsPaginationDTO}
     * @memberof SearchUserRunsParamsDTO
     */
    pagination?: QueryLeaderboardParamsPaginationDTO;
    /**
     * 
     * @type {NqlQueryParamsDTO}
     * @memberof SearchUserRunsParamsDTO
     */
    query?: NqlQueryParamsDTO;
    /**
     * 
     * @type {QueryLeaderboardParamsSortingParamsDTO}
     * @memberof SearchUserRunsParamsDTO
     */
    sorting?: QueryLeaderboardParamsSortingParamsDTO;
    /**
     * 
     * @type {string}
     * @memberof SearchUserRunsParamsDTO
     */
    username?: string;
}

/**
 * Check if a given object implements the SearchUserRunsParamsDTO interface.
 */
export function instanceOfSearchUserRunsParamsDTO(value: object): value is SearchUserRunsParamsDTO {
    return true;
}

export function SearchUserRunsParamsDTOFromJSON(json: any): SearchUserRunsParamsDTO {
    return SearchUserRunsParamsDTOFromJSONTyped(json, false);
}

export function SearchUserRunsParamsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchUserRunsParamsDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'experimentLeader': json['experimentLeader'] == null ? undefined : json['experimentLeader'],
        'pagination': json['pagination'] == null ? undefined : QueryLeaderboardParamsPaginationDTOFromJSON(json['pagination']),
        'query': json['query'] == null ? undefined : NqlQueryParamsDTOFromJSON(json['query']),
        'sorting': json['sorting'] == null ? undefined : QueryLeaderboardParamsSortingParamsDTOFromJSON(json['sorting']),
        'username': json['username'] == null ? undefined : json['username'],
    };
}

export function SearchUserRunsParamsDTOToJSON(value?: SearchUserRunsParamsDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'experimentLeader': value['experimentLeader'],
        'pagination': QueryLeaderboardParamsPaginationDTOToJSON(value['pagination']),
        'query': NqlQueryParamsDTOToJSON(value['query']),
        'sorting': QueryLeaderboardParamsSortingParamsDTOToJSON(value['sorting']),
        'username': value['username'],
    };
}

